import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post';

export default {
  list(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/digital-mail-restrictions${queryString}`);
  },
  get(id) {
    return axios.get(`${base}/digital-mail-restrictions/single/${id}`);
  },
  getForPrisoner(prisonerNumber) {
    return axios.get(`${base}/digital-mail-restrictions/prisoner/${prisonerNumber}`);
  },
  create(dto) {
    return axios.post(`${base}/post/digital/restriction`, dto);
  },
  delete(id) {
    return axios.delete(`${base}/post/digital/restriction/${id}`);
  },
};
